/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_EllipsisInputs */



/**
* | output |
* | --- |
* | "Import..." |
*
* @param {Import_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_ellipsis = /** @type {((inputs?: Import_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importare...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进口...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("輸入...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात करना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar...")
	return /** @type {LocalizedString} */ ("Import...")
});